var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex-center"},[(_vm.dataFetched && !_vm.redirectingToSso)?_c('login-signup',{attrs:{"credentials":_vm.loginCredentials,"form-type":"login"},on:{"prev":_vm.backToMenu}}):(_vm.redirectingToSso || (!_vm.dataFetched && _vm.cssLoaded))?_c('loading-spinner',{staticClass:"loading-wrapper"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }